import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router/index.js'
import app from './app'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // url: 'https://app-yaqui.herokuapp.com/api/',
    url: 'https://yaqui.mecasite.com/api/',
    // url: 'http://localhost:5103/api/',
    token: null,
    user: null,
    showEditItemsModal: false,
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      localStorage.setItem('tk', token)
      state.token = token
    },
    refreshShowEditItemsModal(state, payload) {
      state.showEditItemsModal = payload
    },
  },
  actions: {
    async onFileSelected(context, { filename, file }) {
      try {
        console.log('subiendo archivo...')
        const formData = new FormData()
        formData.append('name', 'my-picture')
        formData.append('file', file)
        const url = `${context.state.url}subirarchivos2/${filename}`
        const opts = {
          method: 'POST',
          body: formData,
        }
        const req = await fetch(url, opts)
        if (req.ok) {
          return true
        }
      } catch (error) {
        console.log('error in onfileselected', error)

        return false
      }
    },
    async login(context, { data }) {
      try {
        const options = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }
        const req = await fetch(`${context.state.url}usuarios/autenticateAdmin`, options)
        const res = await req.json()

        // console.log(res)
        context.state.token = res.token
        localStorage.setItem('tk', res.token)
        localStorage.setItem('user', JSON.stringify(res.data))
        if (res.error) {
          // this.$swal({title:"Aviso", text:"Datos almacenados correctamente", icon:"success"})
          alert(res.error)

          return
        }

        // console.log('login')
        return res
      } catch (error) {
        console.error('error', error)

        return 0
      }
    },
    async get(context, { path }) {
      try {
        const token = localStorage.getItem('tk')
        const options = {
          method: 'GET',
          headers: {
            'access-token': token,
            'Content-Type': 'application/json',
          },
        }
        const req = await fetch(context.state.url + path, options)
        const res = await req.json()
        if (res.mensaje == 'Token inválida') {
          router.push('/')
        }
        if (res.error) {
          console.error(res.error)
          alert(res.mensaje)
        } else {
          return res
        }
      } catch (error) {
        console.error('error', error)

        return error
      }
    },
    async post(context, { path, data }) {
      try {
        const token = localStorage.getItem('tk')
        const options = {
          method: 'POST',
          headers: {
            'access-token': token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
        const req = await fetch(context.state.url + path, options)
        const res = await req.json()
        if (res.mensaje == 'Token inválida') {
          router.push('/')
        }
        if (res.error) {
          alert(res.error)
        } else {
          return res
        }
      } catch (error) {
        console.error('error---------->', error)

        return error
      }
    },
    async put(context, { path, data }) {
      try {
        const token = localStorage.getItem('tk')
        const options = {
          method: 'PUT',
          headers: {
            'access-token': token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
        const req = await fetch(context.state.url + path, options)
        const res = await req.json()
        if (res.mensaje == 'Token inválida') {
          router.push('/')
        }
        if (res.error) {
          alert(res.error)
        } else {
          return res
        }
      } catch (error) {
        console.error('error---------->', error)

        return error
      }
    },
    async delete(context, { path }) {
      try {
        const token = localStorage.getItem('tk')
        const options = {
          method: 'DELETE',
          headers: {
            'access-token': token,
            'Content-Type': 'application/json',
          },
        }
        const req = await fetch(context.state.url + path, options)

        // console.log(req)
        const res = await req.json()
        if (res.mensaje == 'Token inválida') {
          router.push('/')
        }
        if (req.status != 200) {
          alert(req.error)
        } else {
          return req
        }
      } catch (error) {
        console.error('error---------->', error)

        return error
      }
    },
  },
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
})
